import React, { useEffect, useState } from "react";
import styles from "./AdminVideo.module.css";
import Loader from "../../../../Loader";
import { Link, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../../../axios";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";

function GridVideoAdminInfo() {
  const [isLoading, setIsLoading] = useState(false);
  const [existFolderData, setExistFolderData] = useState([]);
  const navigate = useNavigate();
  const userJSON = sessionStorage.getItem("userDetails");
  let user = null;
  let user_type = null;

  if (userJSON) {
    user = JSON.parse(userJSON);
    user_type = user?.user_type || null;
  }

  const hasGalleryAccess = user?.menu_list?.some((id) => id >= 49 && id <= 61);

  // Fetching video data when the component mounts
  useEffect(() => {
    // if (user_type !== 2) return; // Ensure only valid users can fetch data
    setIsLoading(true);

    // Send API request to fetch the video folders
    AxiosInstance.post("/api/gallery/list", folderPayloadImage)
      .then((res) => {
        const seenFolders = new Set();
        const listObject = res.data?.data
          // ?.filter((item) => {
          //   // Filter by img_type === 0 and unique folder_name
          //   if (item.img_type === 0 && !seenFolders.has(item.folder_name)) {
          //     seenFolders.add(item.folder_name);
          //     return true;
          //   }
          //   return false;
          // })
          .map((item) => ({
            folderName: item.folder_name,
            image: item.gallery_path, // This should be the YouTube ID or URL
            displayOption: item.display_option,
            id: item.folder_id,
          }));

        // Sort the list to show `display_option == 0` at the end
        const sortedList = listObject.sort(
          (a, b) => b.displayOption - a.displayOption
        );

        setExistFolderData(sortedList);
      })
      .catch((error) => {
        console.error("Error fetching gallery data:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  // Payload to filter the video list API based on folderName and other params
  const folderPayloadImage = {
    img_type: 0, // 0 for video
    is_admin: user_type === 1 ? 1 : 0,
    page: "",
    page_size: "",
    folder_id: "",
  };
  // Handle click event to navigate to a specific folder details page
  const handleFolderClick = (id) => {
    navigate(`/ViewVideos/${id}`);
  };
  // Navigate back to home
  const handleBackHome = () => {
    navigate(`/`);
  };

  // Navigate to Add New Video page
  const handleSubmit = () => {
    navigate(`/AddVideoAdmin`);
  };
  const handleFolderSubmit = () => {
    navigate(`/AddFolderAdmin/0`);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Videos</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            {/* <li className="ListBtnItems">
              <Link
                onClick={handleBackHome}
                to="javascript:void(0)"
                className="secondaryButton"
              >
                Back to Home
              </Link>
            </li> */}
            {(user_type === 1 || hasGalleryAccess) && (
              <>
                <li class="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={handleFolderSubmit}
                    className="primaryButton text-center "
                    variant="primary"
                  >
                    Add New Folder
                  </Link>
                </li>
                <li className="ListBtnItems">
                  <Link
                    to="javascript:void(0)"
                    onClick={handleSubmit}
                    className="primaryButton text-center"
                    variant="primary"
                  >
                    Add New Video
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      {existFolderData.length > 0 ? (
        <>
          <div className={`${styles.gridContainer} row pt-2`}>
            {existFolderData.map((item, index) => {
              let thumbnailUrl = `https://aiasatest.annaiasacademy.com/api/uploads/signature/default_video.jpg`;
              if (
                item.image.includes("youtube.com") ||
                item.image.includes("youtu.be")
              ) {
                const youtubeRegex =
                  /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
                const match = item.image.match(youtubeRegex);
                if (match) {
                  const videoId = match[1];
                  thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                } else {
                  thumbnailUrl = item.image;
                }
              }

              return (
                <div
                  key={index}
                  className="col-md-3 col-12 mb-4"
                  onClick={() => handleFolderClick(item.id)}
                >
                  <div className={`${styles.card} card text-center`}>
                    <div className={styles.imageContainer}>
                      <img
                        // src={videoUrl} // Embed the YouTube video using the video ID
                        src={thumbnailUrl}
                        loading="lazy"
                        alt={item.folderName || "Image"}
                        className={`${styles.thumbnail} card-img-top`}
                        style={{
                          filter:
                            thumbnailUrl ==
                            "https://aiasatest.annaiasacademy.com/api/uploads/signature/default_video.jpg"
                              ? "blur(2px)"
                              : "",
                        }}
                      />

                      <button className={`${styles.viewButton} btn`}>
                        View Videos
                      </button>
                    </div>
                    <div
                      className={`${styles.folderName} card-body`}
                      title={item.folderName || "Untitled"}
                    >
                      {item.folderName || "Untitled"}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <p style={{ textAlign: "center" }}>No Records to display</p>
        </>
      )}
    </div>
  );
}

export default GridVideoAdminInfo;
